import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { MAX_FILES_NUMBER, UploadWindowWebComponentSchema } from '../types';
import { convertUnits } from '../utils';
import { RequiredValidator } from '../../../ui/gzForm/validators/required.validator';
import { translateFn } from '../../../utils/translator.helper';

export class UploadWindowView extends BaseWebComponentView {
  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');
    this.dom.$title = this.shadow.querySelector('#title');
    this.dom.$uploadPathField = this.shadow.querySelector('#upload-path-field');
    this.dom.$pathInput = this.shadow.querySelector('#upload-path-input');
    this.dom.$selectFilesField = this.shadow.querySelector('#select-files-field');
    this.dom.$selectFilesDescription = this.shadow.querySelector('#select-files-description');
    this.dom.filesInput = this.shadow.querySelector('#files-input');
    this.dom.$browseButton = this.shadow.querySelector('#browse-button');
    this.dom.$filesTitleContainer = this.shadow.querySelector('#files-title-container');
    this.dom.$filesTitle = this.shadow.querySelector('#files-title');
    this.dom.$filesSize = this.shadow.querySelector('#files-size');
    this.dom.$filesList = this.shadow.querySelector('#files-list');
    this.dom.$filesNumberTitleContainer = this.shadow.querySelector('#files-number-title-container');
    this.dom.$filesNumberTitle = this.shadow.querySelector('#files-number-title');
    this.dom.$filesNumber = this.shadow.querySelector('#files-number');

    this.getTranslations();
    this.setTranslatedStrings();
  }

  public setTranslatedStrings() {
    this.dom.$title.innerText = this.translations.title;
    this.dom.$uploadPathField.label = this.translations.uploadPathLabel;
    this.dom.$pathInput.placeholder = this.translations.inputPathPlaceholder;
    this.dom.$selectFilesField.label = this.translations.selectFilesFieldLabel;
    this.dom.$browseButton.textContent = this.translations.browseButton;
    this.dom.$filesTitle.innerText = this.translations.filesTitle + ' :';
    this.dom.$filesNumberTitle.innerText = this.translations.filesNumberTitle + ' :';
  }

  public getTranslations() {
    this.translations = this.stringsTranslator.getUploadWindowTranslations();

    return this.translations;
  }

  private setSelectFilesDescription(maxFilesSize: number) {
    this.translations.selectFilesDescription = translateFn(
      'Select no more than {MAX_NUMBER} files to upload. The overall upload size cannot exceed {MAX_SIZE}',
      {
        MAX_SIZE: convertUnits(maxFilesSize),
        MAX_NUMBER: MAX_FILES_NUMBER,
      }
    );
    this.dom.$selectFilesDescription.innerText = this.translations.selectFilesDescription;
  }

  buildSuccessView(data: UploadWindowWebComponentSchema) {
    this.dom.$uploadPathField.Validators = [RequiredValidator(this.commonStrings.requiredField)];

    this.dom.$uploadPathField.value = data.path;
    this.dom.$uploadPathField.manualValidation = true;

    this.dom.$filesSize.innerText = `${convertUnits(data.filesSize)} / ${convertUnits(data.maxFilesSize)}`;
    this.dom.$filesNumber.innerText = `${data.filesNumber} / ${MAX_FILES_NUMBER}`;

    this.setSelectFilesDescription(data.maxFilesSize)
  }
}
